<script>
    import { theme, isDarkTheme } from '../../../store.js';

    const toggleTheme = () => {
        theme.update(themeState => {
            if ( themeState === 'white_theme' ) {
                localStorage.setItem('theme', 'dark_theme');
                document.documentElement.className = 'dark_theme';
                return themeState = 'dark_theme';
            } else {
                localStorage.setItem('theme', 'white_theme');
                document.documentElement.className = 'white_theme';
                return themeState = 'white_theme';
            }
        });
    }

</script>

<span class="toggle">
    <input class="tgl tgl-flat" id="cb2" type="checkbox" bind:checked={ $isDarkTheme } on:click={ toggleTheme }>
    <label class="tgl-btn" for="cb2"></label>
</span>